import { render, staticRenderFns } from "./CertVerify.vue?vue&type=template&id=873019f0&scoped=true"
import script from "./CertVerify.vue?vue&type=script&lang=js"
export * from "./CertVerify.vue?vue&type=script&lang=js"
import style0 from "./CertVerify.vue?vue&type=style&index=0&id=873019f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873019f0",
  null
  
)

export default component.exports